// src/components/common/LoadingSpinner.tsx
import clsx from 'clsx';
import React from 'react';

interface LoadingSpinnerProps {
    size?: 'sm' | 'md' | 'lg';
    fullPage?: boolean;
    text?: string;
    noPadding?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
    size = 'md',
    fullPage = false,
    text,
    noPadding = false
}) => {
    const getSizeClasses = () => {
        switch (size) {
            case 'sm':
                return 'h-4 w-4 border-2';
            case 'lg':
                return 'h-12 w-12 border-4';
            default:
                return 'h-8 w-8 border-3';
        }
    };

    const spinner = (
        <div className="flex flex-col items-center justify-center">
            <div className={`${getSizeClasses()} animate-spin rounded-full border-gray-300 border-t-indigo-600`}></div>
            {text && <p className="mt-3 text-sm font-medium text-gray-500">{text}</p>}
        </div>
    );

    if (fullPage) {
        return (
            <div className="fixed inset-0 bg-white bg-opacity-75 flex items-center justify-center z-50">
                {spinner}
            </div>
        );
    }

    return (
        <div className={clsx(
            "flex items-center justify-center",
            !noPadding && "py-12"
        )}>
            {spinner}
        </div>
    );
};

export default LoadingSpinner;
